const FETCH_WATCH_LATER_STORIES = 'watchLaterList/FETCH_WATCH_LATER_STORIES';

const DELETE_WATCH_LATER_STORY = 'watchLaterList/DELETE_WATCH_LATER_STORY';

export default {
  FETCH_WATCH_LATER_STORIES,
  DELETE_WATCH_LATER_STORY,
};



// WEBPACK FOOTER //
// ./src/app/redux/front/watchLaterList/types.js